import Loadable from 'react-loadable';

const EventListPanelLazyLoad = Loadable({
  loader: () => import(/* webpackChunkName: "swi-eventListPanel" */ '../react-event-list-panel/container'),
  loading: () => null,
});

export default EventListPanelLazyLoad;
